import { patchSessionPackage, postCoachLecture } from '#api/lectures';
import { useToast } from '#providers/ToastProvider';
import { IPostCoachLecture, SessionType } from '#types/lectures';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

export interface SubmitLectureProps {
  form: IPostCoachLecture;
  multiCountPrice: SessionType[];
}

export const useSubmitCoachLecture = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: async ({ form, multiCountPrice }: SubmitLectureProps) => {
      const response = await postCoachLecture(form);
      const lectureId = response.id;
      await Promise.all([
        multiCountPrice.length > 0 &&
          patchSessionPackage(
            multiCountPrice.filter(v => v.price),
            lectureId
          )
      ]);
    },
    onSuccess: () => {
      showToast({
        message: '수업 등록에 성공하였습니다.'
      });
      queryClient.invalidateQueries({
        queryKey: ['COACH_LECTURES']
      });
      navigate(-1);
    },
    onError: (err: any) => {
      showToast({
        type: 'fail',
        message: '수업 등록에 실패하였습니다.'
      });
    }
  });
};
